import { DEFAULT_DOWNSTREAM_HANDLING_COLOR } from "@/pages/reporting_v2/constants";

type Props = {
  name: string;
  color?: string;
};

export const ReportingDownstreamHandlingBadge: React.FC<Props> = ({
  name,
  color: sanityColor,
}) => {
  const color = sanityColor || DEFAULT_DOWNSTREAM_HANDLING_COLOR;

  return (
    <div className="mt-[6px]">
      <span
        className="inline-flex items-center gap-[5px] rounded-[4px] px-[8px] py-[2px] text-[9.5px] font-bold tracking-[0.03em] whitespace-nowrap uppercase"
        style={{
          color: `color-mix(in srgb, ${color} 65%, black)`,
          background: `color-mix(in srgb, ${color} 18%, white)`,
        }}
      >
        <span
          className="h-[6px] w-[6px] flex-none rounded-full"
          style={{ background: color }}
        />
        {name}
      </span>
    </div>
  );
};
